const merchandiseCredit = {
  merchandiseCredit: {
    noFile: '選択したファイルがありません',
    fileName: 'ファイル名',
    software_service: 'ソフトウェアサービス',
    hardware_product: 'ハードウェア製品',
    sampleFileNameUS: '商品与信US',
    sampleFileNameAU: '商品与信AU',
    sampleFileNameNL: '商品与信NL',
    sampleFileNameBE: '商品与信BE',
    sampleFileNameMX: '商品与信MX',
    sampleFileNameFR: '商品与信FR',
    rowNumber: '行番号',
    errorMessage: 'メッセージ'
  }
};

export default merchandiseCredit;
